/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="productBundles.module.ts" />

module Meevo.Plugins.ProductBundles {

    class ProductBundlesController extends Meevo.Components.BaseClasses.DataMaintenanceControllerBase {

        static $inject = [
            "meevo.AppSettings",
            "meevo.components.common.DataService",
            "meevo.components.modal.ModalService",
            "meevo.components.common.IdentityService",
            "meevo.components.logging.LoggingService",
            "meevo.components.common.SecurityService",
            "meevo.components.tracking.TrackingService",
            "$rootScope",
            "$scope",
            "$state",
            "meevo.ContextParams",
            'meevo.components.short-cuts.ShortCutsService',
            "meevo.components.busy.BusyService",
            "$translate"
        ];

        constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected loggingService: Meevo.Components.Logging.ILoggingService,
            protected securityService: Meevo.Components.Common.ISecurityService,
            protected trackingService: Meevo.Components.Tracking.ITrackingService,
            protected $rootScope: angular.IRootScopeService,
            protected $scope: angular.IScope,
            protected $state: any,
            protected contextParams: any,
            protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected $translate: angular.translate.ITranslateService) {
            super(appSettings, dataService, modalService, identityService, loggingService, $scope, contextParams, $state, $rootScope, shortCutsService);

            this.preSearch();
        }

        public preSearch(): void {
            this.searchContextCriteria =
                {
                    "coBusinessTypeId": "00000000-0000-0000-0000-000000000001",
                    "coFilterByLocationId": null,
                    "coSearchResultFilter": 0,
                    "coSearchType": 0,
                    "filter": "",
                    "includeActive": true,
                    "includeDeleted": false,
                    "includeCustomProductBundle": true,
                    "excludeCustomProductBundle":false,
                    "location": null,
                    "maintenanceMode": true,
                    "notForSale": false,
                    "isProductBundle": true
                };
            if (this.identityService.inCentralOfficeMode()) {
                if (this.identityService["identity"].centralOfficeId != this.identityService["identity"].locationId) {
                    this.searchContextCriteria["location"] = {
                        "id": this.identityService["identity"].locationId
                    };
                    this.searchContextCriteria["coFilterByLocationId"] = this.identityService["identity"].locationId;
                    this.searchContextCriteria["coSearchType"] = 1;
                }
            }
            else {
                this.searchContextCriteria["coSearchType"] = null;
            }
        }
        /**
         * Creates the context for editing/adding an item.
         * @return {}
         */
        setExcludeCustomBundle(criteria: any) {
            criteria["excludeCustomProductBundle"] = !criteria["includeCustomProductBundle"];
        }
        createContext(): void {
            this.busyService.start();
            this.securityService.checkSection(this.meevoSecurityKeys.DATA_PRODUCTBUNDLE).then(() => {
                this.busyService.stop();
                this.context = new ProductBundlesContext(this.appSettings, this.dataService, this.modalService, this.identityService, this.loggingService, this.securityService, this.trackingService, this.$translate);
                this.context.activate(this.selectedItemId, null, this.asLocationId);
                this.context.deactivate = () => {
                    this.visualState = Model.MaintenanceFormVisualState.Search;
                };
                // Use translate service to populate field list
                this.context.locationFieldList =
                    [
                        { field: 'ObjectState', label: this.$translate.instant("HEADER_STATUS"), checked: false },
                        { field: 'Retail', label: this.$translate.instant("LABEL_BUNDLE_PRICE"), checked: false },
                        { field: 'NotForSale', label: this.$translate.instant("LABEL_NOT_FOR_SALE"), checked: false }                    
                    ];
            }).catch(() => {
                this.busyService.stop();
            });
        }

        preSearchCallback(criteria, rootCriteria): void {
            if (!criteria.includeActive && !criteria.includeDeleted) {
                criteria.includeActive = true;
            }
            rootCriteria["isProductBundle"] = true;
        }

        /**
         * Flear field from advanced search criteria
         * @param field
         * @param {AdvancedSearchFilter} criteria
         * @param {AdvancedSearchFilter} rootCriteria
         * @param {Function} searchCallback
         * @param $event
         */
        clearField(field, criteria: any, rootCriteria: any, searchCallback: Function, $event?): void {
            if ($event) {
                $event.stopPropagation();
            }

            criteria[field] = this.searchContextCriteria[field] = (typeof this.searchContextCriteria[field]) === 'boolean' ? false: undefined;
            if (angular.isFunction(searchCallback)) {
                searchCallback();
            }
        }


    }
    angular.module('meevo.plugins.productBundles')
        .controller('meevo.plugins.productBundles.ProductBundlesController', ProductBundlesController);
}